export const GET_ALL_PRODUCT_CATEGORIES = "GET_ALL_PRODUCT_CATEGORIES"
export const GET_ALL_PRODUCT_CATEGORIES_RESPONSE_SUCCESS =
  "GET_ALL_PRODUCT_CATEGORIES_RESPONSE_SUCCESS"
